import { ref } from 'vue'
export const extractText = (html) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  const content = doc.body.textContent || ""
  return content.replace(/\s+/g, '');
}

export const useWindowResize = () => {

  const windowSize = ref(window.innerWidth)

  function debounce(fn, wait = 50, immediate) {
    let timer = null
    return function(...args) {
      const context = this
      if (timer) clearTimeout(timer)
      if (immediate && !timer) {
        fn.apply(context, args)
      }

      timer = setTimeout(() => {
        fn.apply(context, args)
      }, wait)
    }
  }

  function handleWindowResize(e) {
    if(typeof e.target.innerWidth !== 'number' || isNaN(e.target.innerWidth))
      return
console.log(' e.target.innerWidth --------->',  e.target.innerWidth)
    windowSize.value = e.target.innerWidth
  }

  const handleWindowResizeWithDebounce = debounce(handleWindowResize,300)

  return {
    handleWindowResizeWithDebounce,
    windowSize
  }
}